/**
 * <TutorLiveEndDialog> — « Fin » : clôturer le live, ou le quitter (molecule).
 *
 * L'ancien dialogue du pied (`LiveModeFooter`, `onExitPress`), une question et deux réponses au plus,
 * l'annulation en sortie :
 *  - le live n'est pas encore clôturé : « Veux-tu mettre fin au live ? » — « Clôturer et envoyer les
 *    rapports » (le geste attendu : il ouvre la prescription de Sam, puis le bilan) et « Quitter sans
 *    clôturer » (on revient plus tard) ;
 *  - il l'est déjà (`finalized`) : « Veux-tu vraiment quitter ? » — « Quitter le live » seul.
 *
 * Le geste en cours fait tourner son bouton (`finalizing`, `leaving`) ; la carte reste.
 * Un `<ConfirmDialog>`, sa deuxième réponse comprise.
 */
import React from "react"

import { ConfirmDialog } from "../ConfirmDialog"

export type TutorLiveEndDialogProps = {
    visible: boolean
    /** Le live est déjà clôturé aujourd'hui : il ne reste qu'à quitter. Défaut `false`. */
    finalized?: boolean
    onFinalize: () => void
    onLeave: () => void
    onCancel: () => void
    finalizing?: boolean
    leaving?: boolean
    testID?: string
}

const TEXTS = {
    title: "Veux-tu mettre fin au live ?",
    message: "Si tu le clôtures, il ne sera plus accessible aujourd'hui.",
    finalize: "Clôturer et envoyer les rapports",
    leaveOpen: "Quitter sans clôturer",
    finalizedTitle: "Veux-tu vraiment quitter ?",
    finalizedMessage: "Le live est déjà clôturé.",
    leave: "Quitter le live",
}

export function TutorLiveEndDialog(props: TutorLiveEndDialogProps) {
    const {
        visible,
        finalized = false,
        onFinalize,
        onLeave,
        onCancel,
        finalizing = false,
        leaving = false,
        testID,
    } = props

    if (finalized) {
        return (
            <ConfirmDialog
                visible={visible}
                title={TEXTS.finalizedTitle}
                message={TEXTS.finalizedMessage}
                confirmLabel={TEXTS.leave}
                confirmLoading={leaving}
                onConfirm={onLeave}
                onCancel={onCancel}
                testID={testID}
            />
        )
    }
    return (
        <ConfirmDialog
            visible={visible}
            title={TEXTS.title}
            message={TEXTS.message}
            confirmLabel={TEXTS.finalize}
            confirmLoading={finalizing}
            danger={false}
            secondary={{ label: TEXTS.leaveOpen, onPress: onLeave, loading: leaving }}
            onConfirm={onFinalize}
            onCancel={onCancel}
            testID={testID}
        />
    )
}
